import { getCompanyCodeFromToken } from "./authService";
import { API_URL } from "./apiConfig";

const companyCode = getCompanyCodeFromToken();

export const fetchActiveDepartments = async () => {
  try {
    const response = await fetch(`${API_URL}Department/GetActiveDepartments/${companyCode}`);
    if (!response.ok) throw new Error("Failed to fetch active departments");
    return await response.json();
  } catch (error) {
    console.error("Error fetching active departments:", error);
    throw error;
  }
};

export const fetchDepartments = async () => {
  try {
    const response = await fetch(`${API_URL}Department/GetDepartment/${companyCode}`);
    if (!response.ok) throw new Error("Failed to fetch departments");
    return await response.json();
  } catch (error) {
    console.error("Error fetching departments:", error);
    return [];
  }
};

export const toggleDepartmentStatus = async (departmentId, isActive) => {
  try {
    const response = await fetch(`${API_URL}Department/${departmentId}/status`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(isActive),
    });
    if (!response.ok) throw new Error('Failed to toggle department status');
    const result = await response.json();
    return result.success;
  } catch (error) {
    console.error('Error toggling department status:', error);
    throw error;
  }
};

export const addDepartment = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Department/AddDepartment`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const updateDepartment = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Department/UpdateDepartment`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};
